import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/contexts/auth-context';
import { api } from '@/lib/api';
import {
  Workspace,
  WorkspaceMembership,
  WorkspaceRegisterInput,
  Broadcast,
} from '@/types/superadmin';

export function useMyWorkspaces() {
  const { token } = useAuth();
  return useQuery<WorkspaceMembership[]>({
    queryKey: ['workspaces', 'my'],
    queryFn: async () => {
      const { data } = await api.get('/workspaces/my');
      return data;
    },
    enabled: Boolean(token),
    staleTime: 1000 * 30,
  });
}

export function useActiveBroadcast() {
  const { token } = useAuth();
  return useQuery<Broadcast | null>({
    queryKey: ['workspaces', 'active-broadcast'],
    queryFn: async () => {
      const { data } = await api.get('/workspaces/active-broadcast');
      return data;
    },
    enabled: Boolean(token),
    refetchInterval: 60000,
  });
}

export function useRegisterWorkspace() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: WorkspaceRegisterInput) => {
      const { data } = await api.post<Workspace>('/workspaces/register', payload);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['superadmin'] });
      queryClient.invalidateQueries({ queryKey: ['workspaces'] });
      queryClient.invalidateQueries({ queryKey: ['properties'] });
    },
  });
}
